import React from 'react';
import './neonstack.css';

const NeonStack = () => {
  return (
    <>
      <div className='neon-stack-container'>
        <div className='neon-stack-wrapper'>
          <div class='neon-stack-card'>
            <div class='neon-stack-back'>
              <div class='neon-stack-blob'></div>
              <div class='neon-stack-blob'></div>
              <div class='neon-stack-blob'></div>
              <div class='neon-stack-blob'></div>
              <div class='neon-stack-blob'></div>
            </div>
            <div class='neon-stack-text'>
              <h3>Lorem</h3>
              Quod ducimus deleniti magnam molestiae recusandae maxime laborum,
              amet blanditiis sequi culpa, eius nemo!
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NeonStack;
